import { Fragment } from 'react';

import { Button, PageTitle } from '@dec/shared';
import { ButtonAction } from '@dec/shared';
import { HookFormResolver, Text, TextArea } from '@dec/shared';
import { BtnGroup, BtnToolbar, Col, Row } from '@dec/shared';
import env from 'env';
import * as icon from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import DateParser from 'utils/date';

import { useGetTaxReturnById } from '../TaxReturnList/hooks';
import { headers, label } from '../TaxReturnList/translation';

interface TaxReturnGeneralParam {
  taxReturnId: string;
}
export const TaxReturnGeneral = (props: TaxReturnGeneralParam) => {
  const { taxReturnId } = props;
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const onCancel = () => {
    navigate(`/reports/taxreturn`);
  };
  const { loading, taxreturn } = useGetTaxReturnById(taxReturnId);

  if (loading) {
    return <></>;
  }

  return (
    <HookFormResolver onSubmit={() => {}}>
      {() => {
        return (
          <Fragment>
            <Row>
              <Col>
                <Text
                  label={label(t, 'taxreturnNumber')}
                  defaultValue={taxreturn?.taxReturnNumber}
                  readonly={true}
                  name="taxreturnNumber"
                />
              </Col>
              <Col>
                <Text
                  label={label(t, 'name')}
                  readonly={true}
                  defaultValue={taxreturn?.taxpayer?.name}
                  name="name"
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Text
                  label={t('config.tin')}
                  readonly={true}
                  defaultValue={taxreturn?.taxpayer?.tin}
                  name="nit"
                />
              </Col>
              <Col>
                <Text
                  label={label(t, 'createDate')}
                  readonly={true}
                  defaultValue={DateParser.toString(taxreturn?.createdDate)}
                  name="createdDate"
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Text
                  label={label(t, 'taxreturnType')}
                  readonly={true}
                  defaultValue={t(`common.taxreturn-types.${taxreturn?.taxReturnType}`)}
                  name="taxreturnType"
                />
              </Col>
              <Col>
                <Text
                  label={label(t, 'taxreturnStatus')}
                  readonly={true}
                  defaultValue={t(`common.taxreturn-status.${taxreturn?.taxReturnStatus}`)}
                  name="taxreturnStatus"
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Text
                  label={label(t, 'formId')}
                  readonly={true}
                  defaultValue={taxreturn?.formVersion?.form?.code?.toString()}
                  name="formId"
                />
              </Col>
              <Col>
                <Text
                  label={label(t, 'active')}
                  readonly={true}
                  defaultValue={t(`common.yes-no.${taxreturn?.active ? 'yes' : 'no'}`)}
                  name="active"
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <Text
                  label={label(t, 'period')}
                  readonly={true}
                  defaultValue={taxreturn?.period.toString()}
                  name="period"
                />
              </Col>
            </Row>
            {taxreturn?.taxReturnStatus === 'rejected' && taxreturn?.sectionsComments ? (
              <>
                <br />
                <PageTitle title={headers(t, 'rejectionReason')} icon={icon.Yelp} />
                {taxreturn?.sectionsComments
                  .filter((x) => !x.approved)
                  .map((x, i) => {
                    return (
                      <Row key={i}>
                        <Col>
                          <Row>
                            <Col>
                              <h2>{x.sectionName}</h2>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <TextArea
                                rows={3}
                                readOnly={true}
                                label={label(t, 'comments')}
                                defaultValue={x.comment}
                                name={`sections[${i}].comment`}
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    );
                  })}
              </>
            ) : (
              <></>
            )}
            <hr></hr>

            <BtnToolbar>
              <BtnGroup>
                <Button action={ButtonAction.cancel} variant="secondary" onClick={onCancel} />
              </BtnGroup>
              <BtnGroup>
                <Button
                  icon={icon.Printer}
                  text={t('common.label.print')}
                  variant="primary"
                  onClick={() => {
                    const url = `${env.appUrl}/reports/taxreturn/preview/${taxreturn!.id}`;
                    window.open(url, '_blank', 'noopener,noreferrer');
                  }}
                />
              </BtnGroup>
            </BtnToolbar>
          </Fragment>
        );
      }}
    </HookFormResolver>
  );
};
